import type { FC, ReactNode } from 'react'
import styled from 'styled-components'

const Title = styled.h3`
  margin: 0;
  margin-bottom: 10px;
`

const ContentContainer = styled.div`
  margin-top: 5px;
  margin-bottom: 10px;
`

interface Props {
  title?: string
  children: ReactNode
}

const Section: FC<Props> = ({ title, children }: Props) => (
  <div>
    {title && <Title>{title}</Title>}
    <ContentContainer>{children}</ContentContainer>
  </div>
)

export default Section
